// CHG-Meridian ValidationRules
import * as Yup from "yup";

export const characterRestrictionRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,!?&_/\-()]+$/i;
export const characterRestrictionInDocNamesRegExp = /^[a-zA-Z0-9äöüÄÖÜßé '.,_\-()]+$/i;

export const checkRequiredText = (settings) => Yup.string()
    .required("Angabe ist erforderlich")
    .when("settings.isUnicode", {
        is: () => !settings.isUnicode,
        then: Yup.string().matches(characterRestrictionRegExp, "Bitte geben Sie einen gültigen Wert an")
    });